import { ReactComponent as EWBWLogo } from './EW-logo.svg'

export default EWBWLogo
